module.exports = __webpack_public_path__ + "static/media/suit-2.d5ddfb28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/suit-2.jpg
// module id = 1044
// module chunks = 0